import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=f9fae4cc&"
import script from "./MessageReply.vue?vue&type=script&lang=js&"
export * from "./MessageReply.vue?vue&type=script&lang=js&"
import style0 from "./MessageReply.vue?vue&type=style&index=0&id=f9fae4cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports